const headers = (token) => ({
  "Content-Type": "application/json",
  Authorization: `Bearer ${token}`,
});

export const getNotificationSummary = async (token) => {
  const response = await fetch(`${window.constants.api_url}/notification-logs/summary`, {
    method: "GET",
    headers: headers(token),
  });
  return response.json();
};

export const getNotificationLogs = async (token, body) => {
  const response = await fetch(`${window.constants.api_url}/notification-logs`, {
    method: "POST",
    headers: headers(token),
    body: JSON.stringify(body),
  });
  return response.json();
};
